// CurrencyInput.js - manual-entry ₹ field. Shows the raw editable number while focused,
// formats with the ₹ symbol + thousands separators on blur. Raw numeric string is what's
// stored in parent state either way.
import React, { useState } from 'react';

export const formatINR = (value) => {
  const n = Number(value);
  if (!Number.isFinite(n) || value === '' || value === null || value === undefined) return '';
  return `₹${n.toLocaleString('en-IN', { maximumFractionDigits: 2 })}`;
};

const CurrencyInput = ({ value, onChange, className = '', placeholder = '0', disabled = false }) => {
  const [isFocused, setIsFocused] = useState(false);
  const display = isFocused ? (value ?? '') : formatINR(value) || '';

  return (
    <input
      type="text"
      inputMode="decimal"
      value={display}
      disabled={disabled}
      onFocus={() => setIsFocused(true)}
      onBlur={() => setIsFocused(false)}
      onChange={(e) => {
        const raw = e.target.value.replace(/[^0-9.]/g, '');
        onChange(raw);
      }}
      placeholder={placeholder}
      className={className}
    />
  );
};

export default CurrencyInput;
